import { render, staticRenderFns } from "./PotentialRevenueDetails.vue?vue&type=template&id=01b54033&scoped=true&"
import script from "./PotentialRevenueDetails.vue?vue&type=script&lang=js&"
export * from "./PotentialRevenueDetails.vue?vue&type=script&lang=js&"
import style0 from "./PotentialRevenueDetails.vue?vue&type=style&index=0&id=01b54033&prod&scoped=true&lang=css&"
import style1 from "./PotentialRevenueDetails.vue?vue&type=style&index=1&id=01b54033&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b54033",
  null
  
)

export default component.exports